import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

// Function to get the token from local storage or state
const getToken = () => {
  // Retrieve the token from local storage or state
  // For example, if it's stored in local storage:
  const token = localStorage.getItem("token");
  return token;
};

export const TeritaryVehicleCountDashboardReport = async (
  StartDate,
  endDate,
  ZoneId,
  CircleId,
  WardId,
  TransferStationId
) => {
  try {
    let apiUrl =
      API_BASE_URL1 +
      "TransferStationReport/GetTransferStationTertiaryVehicleCountDashboard?";

    // Append StartDate and endDate
    if (StartDate && endDate) {
      apiUrl += `StartDateTime=${StartDate}&EndDateTime=${endDate}`;
    }
    if (ZoneId !== null) {
      apiUrl += `&ZoneId=${ZoneId}`;
    }

    // Append CircleId if not null
    if (CircleId !== null) {
      apiUrl += `&CircleId=${CircleId}`;
    }

    // Append WardId if not null
    if (WardId !== null) {
      apiUrl += `&WardId=${WardId}`;
    }
    // Append TransferStationId if not null
    if (TransferStationId !== null) {
      apiUrl += `&TransferStationId=${TransferStationId}`;
    }

    const token = getToken(); // Get the token
    const response = await axiosInstance.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const TeritaryVehicleDashboardReport = async (
  StartDate,
  endDate,
  TransferStationId
) => {
  try {
    let apiUrl =
      API_BASE_URL1 +
      "TransferStationReport/GetTransferStationTertiaryVehicleReport?";

    // Append StartDate and endDate
    if (StartDate && endDate) {
      apiUrl += `StartDateTime=${StartDate}&EndDateTime=${endDate}`;
    }

    // Append TransferStationId if not null
    if (TransferStationId !== null) {
      apiUrl += `&TransferStationId=${TransferStationId}`;
    }

    const token = getToken(); // Get the token
    const response = await axiosInstance.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
